var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "169B0668-B857-4112-B4DA-6487354E0162") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D---Dashboard_Menu",
    transform: "translate(-22.000000, -151.000000)",
    stroke: "#C6D7EA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1_White",
    transform: "translate(22.500560, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8.47544552 19 8.47544552 4 10.9736668 4 10.9736668 18.465491"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "13.5114143 17.9618783 13.5114143 9 15.9754455 9 15.9754455 16.4825609"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3-Copy-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3 16.5 3 9 5.48921189 9 5.48921189 17.9618783"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 17.5,
    x2: 21.5,
    y2: 21.5,
    id: "Line-2",
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyChart);
export default __webpack_public_path__ + "static/media/magnify-chart.bbb82b4b7f5806302eaa6daaf54d14d3.svg";
export { ForwardRef as ReactComponent };